(() => {
  // Labels for the Hub message log enums. The listing grid and the detail modal both read
  // these filters, so the id-to-name mapping exists once and is sourced from the backend
  // Hms.HubMessageLogs enums via portalEnums.json [HM-11062].

  angular
    .module('app')
    .filter('hubMessageDirection', hubMessageDirection)
    .filter('hubMessageKind', hubMessageKind)
    .filter('hubMessageStatus', hubMessageStatus)
    .filter('hubMessageLeg', hubMessageLeg);

  hubMessageDirection.$inject = ['Hms.HubMessageLogs.HubMessageDirection'];
  hubMessageKind.$inject = ['Hms.HubMessageLogs.HubMessageKind'];
  hubMessageStatus.$inject = ['Hms.HubMessageLogs.HubMessageStatus'];
  hubMessageLeg.$inject = ['Hms.HubMessageLogs.HubMessageLeg'];

  function hubMessageDirection(enumHubMessageDirection) {
    return createEnumNameFilter(enumHubMessageDirection);
  }

  function hubMessageKind(enumHubMessageKind) {
    return createEnumNameFilter(enumHubMessageKind);
  }

  function hubMessageStatus(enumHubMessageStatus) {
    return createEnumNameFilter(enumHubMessageStatus);
  }

  function hubMessageLeg(enumHubMessageLeg) {
    return createEnumNameFilter(enumHubMessageLeg);
  }

  function createEnumNameFilter(enumConstant) {
    return function enumNameFilter(value) {
      // An id we do not recognise falls through to the raw value rather than being
      // labelled as a member we do know. The member name doubles as the localisation
      // key, and ABP renders a missing key as the key wrapped in square brackets, so
      // every member of these enums needs a localisation entry — without one the cell
      // reads as [MemberName].

      const match = enumConstant.values.find((item) => item.id === value);
      return match ? App.localize(match.name) : value;
    };
  }
})();
